<div class="text-box--scrollable" (scroll)="onScroll($event)">
  <div class="text" [innerHTML]="contentMarkup"></div>
</div>